import { formatDocument } from "../../../utils/utils";

const ParticipacaoEmEmpresas = ({ empresas }) => {
  return (
    <>
      <div className="mt-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 bg-slate-50 px-4 py-3">
          <div className="grid grid-cols-5 gap-3 text-[10px] font-semibold uppercase tracking-[0.28em] text-slate-500">
            <div className="col-span-2">Empresa</div>
            <div className="text-center">Entrada</div>
            <div className="text-center">Função</div>
            <div className="text-center">Part. (%)</div>
          </div>
        </div>

        {empresas?.length > 0 && (
          <div className="divide-y divide-slate-100">
            {empresas?.map((empresa, index) => (
              <div
                key={index}
                className={`grid grid-cols-5 gap-3 px-4 py-3 text-sm items-center ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/40"
                } hover:bg-slate-50`}
              >
                <div className="col-span-2">
                  <div className="font-medium text-slate-900">
                    {empresa?.empresa || "-"}
                  </div>
                  <div className="text-[11px] text-slate-500">
                    CNPJ: {empresa?.cnpj ? formatDocument(empresa?.cnpj) : "-"}
                  </div>
                </div>
                <div className="text-center text-slate-700">
                  {empresa?.dataEntrada || "-"}
                </div>
                <div className="text-center text-slate-700">
                  {empresa?.funcao || "-"}
                </div>
                <div className="text-center text-slate-700">
                  {empresa?.participacaoEmPorcentagem ||
                    empresa?.percentualParticipacao ||
                    "-"}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default ParticipacaoEmEmpresas;
